import { api, AxiosRequestConfigWithMetadata } from '../../services/api.service';

export function legalApiLang(i18nLanguage: string): 'en' | 'de' {
  return i18nLanguage?.toUpperCase() === 'EN' ? 'en' : 'de';
}

class LegalApi {
  async getPrivacyPolicyHtml(lang: 'en' | 'de'): Promise<string> {
    const apiCall = await api.get(`/api/public/legal/privacy-policy/${lang}`, {
      responseType: 'text',
      functionName: 'legal_getPrivacyPolicyHtml',
    } as AxiosRequestConfigWithMetadata);
    return apiCall.data as string;
  }

  async getImprintHtml(lang: 'en' | 'de'): Promise<string> {
    const apiCall = await api.get(`/api/public/legal/imprint/${lang}`, {
      responseType: 'text',
      functionName: 'legal_getImprintHtml',
    } as AxiosRequestConfigWithMetadata);
    return apiCall.data as string;
  }
}

export const legalApi = new LegalApi();
